module.exports = __webpack_public_path__ + "static/event_danal_webinar_bg@2x-227a559e674d493df8c7af8ac439722a.png";